import modal from "./modal";

export function openTheModal(selector) {
    if (!modal) return;

    if (modal.isOpen) {
        modal.close();
        setTimeout(open, modal.speed + 100);
    } else {
        open();
    }

    function open() {
        modal.modalContainer = document.querySelector(selector);
        modal.open();
    }
}

let submitButtonText = "";

export function turnIntoLoader(target) {
    if (!target.classList.contains("btn-mini--loading")) {
        target.classList.add("btn-mini--loading");
        if (target.innerHTML) {
            submitButtonText = target.innerHTML;
        }
        target.innerHTML = `
                <svg
                version="1.1"
                id="loader-1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="40px"
                height="40px"
                viewBox="0 0 50 50"
                style="enable-background: new 0 0 50 50"
                xml:space="preserve"
            >
                <path
                    fill="#000"
                    d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
                >
                    <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="rotate"
                        from="0 25 25"
                        to="360 25 25"
                        dur="0.6s"
                        repeatCount="indefinite"
                    />
                </path>
            </svg>
        `;
    }
}

export function turnIntoButton(target) {
    let button;
    if (typeof target === "string") {
        button = document.querySelector(target);
    } else {
        button = target;
    }
    button.classList.remove("btn-mini--loading");
    button.innerHTML = submitButtonText;
}
